import React, { useState } from 'react';
import Validator from 'validatorjs';

import { Field, Form } from 'react-final-form';
import { CheckboxField, SelectField, TextField } from '/components/forms/fields';

import { ValidationService } from '/services';

const purposeOptions = [
    {"label":"te koop","value":"te koop"},
    {"label":"te huur","value":"te huur"},
];

const categoryOptions = [
    {"label":"appartement","value":"appartement"},
    {"label":"grond","value":"grond"},
    {"label":"kantoor","value":"kantoor"},
    {"label":"commercieel","value":"commercieel"},
    {"label":"industrieel","value":"industrieel"},
    {"label":"garage / parking","value":"garage / parking"},
    {"label":"huis","value":"huis"},
];

const EstimateForm = () => {
    const [error, setError] = useState(null);

    const validate = (values) => {
        const rules = {
            firstName: 'required',
            lastName: 'required',
            purpose: 'required',
            category: 'required',
            mobile: 'required',
            email: 'required',
            street: 'required',
            number: 'required',
            postalCode: 'required',
            city: 'required',
            privacy: 'required',
        };

        const names = {
            firstName: 'voornaam',
            lastName: 'achternaam',
            purpose: 'type transactie',
            category: 'type vastgoed',
            mobile: 'telefoon',
            email: 'e-mailadres',
            street: 'straat',
            number: 'nummer',
            box: 'bus',
            postalCode: 'postcode',
            city: 'gemeente',
        };

        return ValidationService.validate(values, rules, names);
    };

    const submit = async (values) => {
        const body = new FormData();
        body.append(window.csrfTokenName, window.csrfTokenValue);
        body.append('firstName', values.firstName);
        body.append('lastName', values.lastName);
        body.append('mobile', values.mobile);
        body.append('email', values.email);

        body.append('street', values.street);
        body.append('number', values.number);
        body.append('box', values.box);
        body.append('postalCode', values.postalCode);
        body.append('city', values.city);

        body.append('purpose', values.purpose && values.purpose.value);
        body.append('category', values.category && values.category.value);

        try {
            const response = await fetch('/index.php?p=actions/immodule/form/estimate', {
                method: 'post',
                body,
            });

            const bodyFromResponse = await response.json();

            if (bodyFromResponse.success) {
                window.location = window.successRedirect;
            } else {
                window.location = window.failureRedirect;
            }
        } catch {
            window.location = window.failureRedirect;
        }
    };

    const render = ({ handleSubmit }) => (
        <>
        { error && (
            <p className="estimate-form__error">{ error }</p>
        )}
        <form className="estimate-form" onSubmit={handleSubmit}>
            <Field
                name="firstName"
                component={TextField}
                label="Voornaam"
                type="text"
                required
            />
            <Field
                name="lastName"
                component={TextField}
                label="Naam"
                type="text"
                required
            />
            <Field
                name="purpose"
                component={SelectField}
                label="Type transactie"
                options={purposeOptions}
                required
            />
            <Field
                name="category"
                component={SelectField}
                label="Type vastgoed"
                options={categoryOptions}
                required
            />
            <Field
                name="mobile"
                component={TextField}
                label="Telefoonnummer"
                type="tel"
                required
            />
            <Field
                name="email"
                component={TextField}
                label="E-mailadres"
                type="email"
                required
            />
            <Field
                name="street"
                component={TextField}
                label="Straat"
                type="text"
                required
            />
            <Field
                name="number"
                component={TextField}
                label="Nummer"
                type="number"
                required
            />
            <Field
                name="box"
                component={TextField}
                label="Bus"
                type="text"
            />
            <Field
                name="postalCode"
                component={TextField}
                label="Postcode"
                type="text"
                required
            />
            <Field
                name="city"
                component={TextField}
                label="Gemeente"
                type="text"
                required
            />
            <Field
                name="privacy"
                component={CheckboxField}
                label={window.privacyMessage}
                type="checkbox"
                required
            />
            <button className="button is-orange font-supplementary--bold" type="submit">
                Verzenden
            </button>
        </form>
        </>
    );

    return (
        <Form
            validate={validate}
            onSubmit={submit}
            render={render}
        />
    );
};

export { EstimateForm };
